import Image from 'app/Components/Shared/Image/image';
import BusinessInvoicesContext, {AccountType} from 'app/Components/Page/BusinessInvoicesPage/BusinessInvoicesContext';
import ProviderManager from 'app/provider/providerManager';
import React, {memo, useEffect, useMemo, useLayoutEffect, useState, useContext} from 'react';
import InnerLoader from 'app/Components/Shared/Loader/InnerLoader';
import {pdfjs, Document, Page} from 'react-pdf';
import isAcrobatInstalled from 'app/utilities/isAcrobatInstalled';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

type Result = {
  error: boolean;
  body: {
    invoiceBase64: string;
    invoiceNumber: string;
  };
};

const PdfViewer = ({src}: {src: string}) => {
  const [numPages, setNumPages] = useState<number | null>(null);
  return (
    <div className='PDFWrapper'>
      <div className='PDFContainer'>
        <Document className='PDFDocument' file={src} onLoadSuccess={({numPages}) => setNumPages(numPages)}>
          {Array.apply(null, Array(numPages))
            .map((_, i) => i + 1)
            .map((page, i) => (
              <Page key={i} className='PDFPage' pageNumber={page} />
            ))}
        </Document>
      </div>
    </div>
  );
};

const BusinessInvoicesPdf = () => {
  const [{pdf}, dispatch] = useContext(BusinessInvoicesContext);
  const [result, setResult] = useState<Result>(null);
  const fallback = useMemo(() => !isAcrobatInstalled(), []);

  useLayoutEffect(() => {
    document.body.style.overflow = pdf != null ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [pdf]);

  useEffect(() => {
    if (result?.error == false) dispatch({type: 'open-pdf-view'});
  }, [result]);

  useEffect(() => {
    setResult(null);
    if (pdf != null) {
      const invoiceOrigin = AccountType[pdf.invoice.invoiceAccountType];
      ProviderManager.getProviderData('getBussinessInvoicesPdf', [pdf.companyId, invoiceOrigin, pdf.invoice.invoiceNumber])
        .then((res) => setResult(res.Body ? {error: false, body: res.Body} : {error: true, body: null}))
        .catch(() => setResult({error: true, body: null}));
    }
  }, [pdf?.invoice]);

  return pdf == null ? null : (
    <div className='BusinessInvoicesPdf'>
      <div className='BusinessInvoicesPdf__header'>חשבונית {pdf.invoice.invoiceNumber}</div>
      <Image className='BusinessInvoicesPdf__back' src={require('./images/icons-arrow-back.svg')} onClick={() => history.back()} />
      {result?.error == false && fallback && <PdfViewer src={`data:application/pdf;base64,${result.body.invoiceBase64}`} />}
      {result?.error == false && !fallback && <iframe src={`data:application/pdf;base64,${result.body.invoiceBase64}`} />}
      {result?.error == true && (
        <div className='BusinessInvoicesPdf__failed'>
          <Image src={require('./images/icons-error.svg')} />
          <h2>איש קשר יקר</h2>
          <p>רק רגע, משהו השתבש.</p>
          <p>לא הצלחנו להציג את החשבונית</p>
          <p>באפשרותכם לשלוח העתק חשבונית מבוקשת למייל</p>
        </div>
      )}
      <InnerLoader isOverlay={false} isLoading={result == null} />
      <div className='BusinessInvoicesPdf__send' onClick={() => dispatch({type: 'open-email', invoices: [pdf.invoice]})}>
        <Image src={require('./images/contact-email.svg')} alt='email' />
        <div>שליחת עותק נאמן למקור</div>
      </div>
    </div>
  );
};
export default memo(BusinessInvoicesPdf);
